module.exports = __webpack_public_path__ + "static/media/oakhouse-logo-square.f301c013.png";